import './SidebarContentDivider.scss';

function SidebarContentDivider(): JSX.Element {
  return <div className="p-my-2 sidebar-content-divider" />;
}

export default SidebarContentDivider;
